import { MessageSquare, Star, Trash2, Eye, EyeOff } from "lucide-react";

export const ReviewsPanel = ({ reviews, onToggleApprove, onRemoveReview }) => (
  <div className="mt-6" data-testid="reviews-panel">
    {reviews.length === 0 ? (
      <div data-testid="reviews-empty" className="rounded-2xl border border-dashed border-border bg-card p-16 text-center">
        <MessageSquare className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
        <p className="font-heading font-bold text-xl text-foreground">No reviews yet</p>
        <p className="mt-2 text-muted-foreground">Reviews left on your Testimonials page will appear here for approval.</p>
      </div>
    ) : (
      <div className="space-y-4">
        {reviews.map((rv) => (
          <div
            key={rv.id}
            data-testid={`review-${rv.id}`}
            className="rounded-2xl border border-border bg-card p-6 grid lg:grid-cols-[1fr,auto] gap-5"
          >
            <div>
              <div className="flex items-center gap-3 flex-wrap">
                <h3 className="font-heading font-bold text-xl text-foreground">{rv.name}</h3>
                <span
                  className={`rounded-full px-3 py-1 text-xs font-bold ${
                    rv.approved ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"
                  }`}
                >
                  {rv.approved ? "Published" : "Pending"}
                </span>
                {rv.location && (
                  <span className="rounded-full bg-muted px-3 py-1 text-xs font-semibold text-muted-foreground">
                    {rv.location}
                  </span>
                )}
              </div>
              <div className="flex text-accent mt-3">
                {[...Array(rv.rating)].map((_, j) => (
                  <Star key={j} className="h-5 w-5 fill-current" />
                ))}
              </div>
              <p className="mt-3 text-slate-300 leading-relaxed">“{rv.quote}”</p>
              <p className="mt-3 text-sm text-muted-foreground">
                {new Date(rv.created_at).toLocaleString()}
              </p>
            </div>
            <div className="flex lg:flex-col gap-2 justify-end">
              <button
                data-testid={`review-approve-${rv.id}`}
                onClick={() => onToggleApprove(rv)}
                className={`inline-flex items-center justify-center gap-2 h-11 px-5 rounded-full font-bold transition-colors whitespace-nowrap ${
                  rv.approved
                    ? "border border-border text-muted-foreground hover:border-accent"
                    : "bg-accent/10 text-accent hover:bg-accent hover:text-white"
                }`}
              >
                {rv.approved ? <><EyeOff className="h-4 w-4" /> Hide</> : <><Eye className="h-4 w-4" /> Publish</>}
              </button>
              <button
                data-testid={`review-delete-${rv.id}`}
                onClick={() => onRemoveReview(rv)}
                className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-full border border-border text-muted-foreground font-semibold hover:border-destructive hover:text-destructive transition-colors"
              >
                <Trash2 className="h-4 w-4" /> Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
